var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$root.isLoading)?[_c('Header'),_c('main',{staticClass:"pt-[107px] relative"},[_c('div',{staticClass:"wrapper py-6"},[_c('router-view')],1)]),_c('Modals')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }